import { motion } from "framer-motion";
import { GALLERY } from "@/data";

const layout = [
  "md:col-span-2 md:row-span-2",
  "",
  "",
  "",
  "md:col-span-2",
  "",
];

export default function Gallery() {
  return (
    <section id="gallery" className="py-20 md:py-28 px-5 md:px-10">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="text-sm font-semibold tracking-wider uppercase text-amber-500">
            Moments of Joy
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            Little learners, big adventures
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Take a peek at the play, creativity, and learning that fill our days.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 auto-rows-[180px] md:auto-rows-[200px]">
          {GALLERY.map((img, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-image-${i}`}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
              className={`relative overflow-hidden rounded-3xl shadow-sm group ${layout[i]}`}
            >
              <img
                src={img.url}
                alt={img.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
